/**
 * External Imports
 */
import { FC, Dispatch, SetStateAction } from 'react';

/**
 * Nexus Imports
 */
import { NeuCard } from '@neutron/react';

/**
 * Internal Imports
 */
import QuestionPart from './QuestionPart';

/**
 * Style Imports
 */
import { NextQuestionIcon } from './Question.styles';

interface IQuestionProps {
  data: any;
  viewOnly: boolean;
  q: any;
  setData: Dispatch<SetStateAction<{}>>;
  updateAggregatePart: (
    aggPart: any,
    questionPartId: string,
    newAnswer: any,
    questions: any
  ) => any;
}

const Question: FC<IQuestionProps> = ({
  data,
  q,
  setData,
  viewOnly,
  updateAggregatePart
}) => {
  return (
    <NeuCard
      id={`Round-Question-Card-${q.questionId}`}
      className="w-75 overflow-visible mt-2 ms-2 pt-1 px-1 pb-3"
      interactive={false}
      color="plain"
      kind="elevated"
      unit="card"
      style={{ flexGrow: 1 }}
    >
      <NeuCard
        unit="content"
        className={`position-relative pr-1${
          q?.questionTags.includes('REQUIRED') ? ' required-content' : ''
        }`}
      >
        {q.questionParts?.map((questionPart: any) =>
          questionPart?.questionCondition?.some((cond: string) =>
            data?.selectedConditions?.some(
              (c: { questionId: string; flags: string[] }) =>
                c.flags.indexOf(cond) !== -1
            )
          ) || !questionPart?.questionCondition?.length ? (
            viewOnly ? (
              <div
                className="d-flex flex-grow-1"
                key={questionPart.questionPartId}
              >
                <NextQuestionIcon className="pt-2" color="blue">
                  subdirectory_arrow_right
                </NextQuestionIcon>
                <QuestionPart
                  key={questionPart.questionPartId}
                  data={data}
                  isRequired={q?.questionTags.includes('REQUIRED-ALL')}
                  quesId={q.questionId}
                  questionPart={questionPart}
                  setData={setData}
                  viewOnly={viewOnly}
                  updateAggregatePart={updateAggregatePart}
                />
              </div>
            ) : (
              <QuestionPart
                key={questionPart.questionPartId}
                data={data}
                isRequired={q?.questionTags.includes('REQUIRED-ALL')}
                quesId={q.questionId}
                questionPart={questionPart}
                setData={setData}
                viewOnly={viewOnly}
                updateAggregatePart={updateAggregatePart}
                tags={q?.questionTags}
              />
            )
          ) : null
        ) ?? []}
      </NeuCard>
    </NeuCard>
  );
};

export default Question;
